import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calcul du taux de sucre dans le sang - Calculatrice de sucre sanguin normal";
const DESCRIPTION =
  "Calcul du taux de sucre dans le sang - Calculatrice de sucre sanguin normal en francais pour estimer vos indicateurs de sante rapidement. Entrez vos donnees et obtenez un resultat clair avec des reperes utiles pour le suivi quotidien.";
const KEYWORDS =
  "calcul du taux de sucre dans le sang de sucre sanguin normal, calculatrice calcul du taux de sucre dans le sang de sucre sanguin normal, calcul en ligne, sante, bien-etre, indicateurs sante, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/blood-sugar-calculator/";
function BloodSugarCalculator() {
  const [sugarLevel, setSugarLevel] = useState("");
  const [testType, setTestType] = useState("Test du sucre aléatoire");
  const [result, setResult] = useState("");
  const [alertClass, setAlertClass] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (sugarLevel) {
        const level = parseFloat(sugarLevel);
        let normalRange;
        let minLevel, maxLevel;
        let message;
        if (testType === "Test du sucre aléatoire") {
          normalRange = "140-200 mg/dl";
          minLevel = 140;
          maxLevel = 200;
        } else if (testType === "Test du sucre à jeun") {
          normalRange = "70-100 mg/dl";
          minLevel = 70;
          maxLevel = 100;
        }
        if (level < minLevel) {
          message = `Avertissement: Le niveau entré ${level} mg/dl est inférieur à la plage normale pour ${testType} (${normalRange}).`;
          setAlertClass("alert alert-warning");
        } else if (level > maxLevel) {
          message = `Avertissement: Le niveau entré ${level} mg/dl est supérieur à la plage normale pour ${testType} (${normalRange}).`;
          setAlertClass("alert alert-warning");
        } else {
          message = `Excellent: Le niveau entré ${level} mg/dl est dans la plage normale pour ${testType} (${normalRange}).`;
          setAlertClass("alert alert-success");
        }
        setResult(message);
      }
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La calculatrice intelligente de sucre dans le sang est un outil utile et fiable
                  qui vous aide à déterminer facilement votre taux de sucre dans le sang. Il vous
                  suffit d'entrer la lecture de votre glucomètre en milligrammes par décilitre
                  (mg/dl) et de choisir le type de test que vous avez effectué (aléatoire ou jeûne).
                  Notre calculatrice vous fournira les résultats instantanément avec une explication
                  simple de ce qu'ils signifient. Que vous soyez diabétique ou que vous souhaitiez
                  simplement surveiller votre santé, notre calculatrice est un outil précieux pour
                  maintenir un contrôle optimal de la glycémie.
                </p>
                <p>Pour calculer le taux de sucre dans le sang, vous pouvez suivre ces étapes:</p>
                <ul>
                  <li>
                    Entrez le taux de sucre dans le sang en milligrammes par décilitre (mg/dl).
                  </li>
                  <li>
                    Choisissez le type de test: test du sucre aléatoire ou test du sucre à jeun.
                  </li>
                </ul>
                <p>Cette calculatrice a été développée pour faciliter la connaissance du taux de sucre dans le sang.</p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <div>
                    <hr />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2" htmlFor="level">
                          Entrez le taux de sucre
                        </label>
                      </b>
                      <input
                        id="level"
                        type="number"
                        value={sugarLevel}
                        onChange={(e) => setSugarLevel(e.target.value)}
                        placeholder="Entrez le taux de sucre"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2" htmlFor="type">
                          Choisir le type de test
                        </label>
                      </b>
                      <select
                        id="type"
                        className="form-control"
                        value={testType}
                        onChange={(e) => setTestType(e.target.value)}
                        style={{ width: "75%" }}
                      >
                        <option value="Test du sucre aléatoire">
                          Test du sucre aléatoire
                        </option>
                        <option value="Test du sucre à jeun">
                          Test du sucre à jeun
                        </option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Calculer                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className={alertClass}>
                      <h4>Résultat:</h4>
                      <p className="text-black">{result}</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
  <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Glycmie normale</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Surveiller sa glycmie</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BloodSugarCalculator;
